/** Client-side debug logging — dev builds only. */
export function devLog(...args: unknown[]): void {
  if (import.meta.env.DEV) {
    console.log(...args);
  }
}

export function devInfo(...args: unknown[]): void {
  if (import.meta.env.DEV) {
    console.info(...args);
  }
}
